<template>
  <div class="page diseaseAnalyzer">
    
    <!-- 헤더 -->
    <div class="container">
    <!--<div class="card introCard">
      <div class="introRow">
        <div class="introCopy">
          <div class="introLine1">질병 선택 후 AI에게</div>
          <div class="introLine1">보험금을 확인하세요.</div>
        </div>
      </div>
    </div>-->
    <!-- ===================== -->
    <!-- 1️⃣ 질병 검색 영역 -->
    <!-- ===================== -->
    <transition name="glass-toast">
      <div v-if="showToast" class="glass-toast">
        <div class="glass-inner">
    
          <div class="glass-icon">
            ⚠
          </div>
    
          <div class="glass-text">
            {{ toastMessage }}
          </div>
    
        </div>
      </div>
    </transition>
    <div class="card">
      <div class="cardTitle">질병 선택</div>
    
      <div class="searchWrap">
      <input
        v-model="searchKeyword"
        placeholder="질병코드 또는 질병명 입력"
        class="input"
        @keyup.enter="searchDisease"
      />
    
      <button class="btnSearchFull" @click="searchDisease">
        🔎 질병 검색
        <span v-if="searchCount > 0" class="searchCount">
          ({{ searchCount }}개)
        </span>
      </button>
    </div>
    
      <!-- 검색 결과 -->
      <div v-if="searchResults.length" class="searchTableWrapper">

        <div
          class="searchTable"
          ref="tableRef"
          @scroll="handleScroll"
        >
          <div
            v-for="item in searchResults"
            :key="item.code"
            class="searchRowItem"
            :class="{ active: isSelected(item.code, item.name) }"
            @click="addDisease(item)"
          >
            <div class="colCode">{{ item.code }}</div>
            <div class="colName">{{ item.name }}</div>
      
            <button
              class="btnSelect"
              @click.stop="addDisease(item)"
            >
              {{ isSelected(item.code) ? "선택됨" : "선택" }}
            </button>
          </div>
        </div>
      
        <!-- 🔥 진짜 페이드 레이어 -->
        <div
          v-if="showFade"
          class="fadeOverlay"
        ></div>
      
        <!-- 개수 표시 -->
        <div v-if="searchCount > 5" class="scrollHint">
          ↓ 총 {{ searchCount }}개의 검색 결과가 있습니다
        </div>
      
      </div>
    
      <!-- 선택된 질병 -->
      <div
        v-for="d in selectedDiseases"
        :key="d.code"
        class="chip"
        @click="removeDisease(d.code)"
      >
        <span class="chipText">
          {{ d.code }} - {{ d.name }}
        </span>
        <span
          class="chipClose"
          @click.stop="removeDisease(d.code)"
        >
          ×
        </span>
      </div>
    </div>

      <!-- ===================== -->
      <!-- 2️⃣ 분석 옵션 -->
      <!-- ===================== -->
      <div class="card">
        <div class="cardTitle">AI 분석 옵션</div>

        <div class="modeButtons">
          <button
            :class="{active:mode==='coverage'}"
            @click="mode='coverage'; closeSearchList()"
          >
            시뮬레이션
          </button>
          <button
            :class="{active:mode==='info'}"
            @click="mode='info'; closeSearchList()"
          >
            질병 설명
          </button>
        </div>

        <!-- 보장 분석 입력 -->
        <div v-if="mode==='coverage'" class="coverageInput">
          <textarea
            v-model="coverageText"
            placeholder="가입한 보장 내용을 입력하세요. 입력하기 어려운 경우 아래에 파일을 업로드 하세요. "
          ></textarea>

          <!-- ===== 드롭존 ===== -->
          <div
            class="dropzone"
            :class="{ over: isOver }"
            @dragenter.prevent="onDragEnter"
            @dragover.prevent="onDragOver"
            @dragleave.prevent="onDragLeave"
            @drop.prevent="onDrop"
            @click="openDzPicker"
            role="button"
            tabindex="0"
          >
            <div class="dz-icon">📎</div>
            <div class="dz-title">
              여기에 보험증권 / 보장분석(메리츠,KB,DB,롯데,한화) / 설계서를 드래그해서 업로드 하거나 클릭하세요
            </div>
            <div class="dz-hint">
              여러 파일 업로드 가능 (PDF, 이미지)
            </div>
          
            <!-- 미니 픽커 -->
            <div v-if="dzPickerOpen" class="dz-picker">
              <button class="dz-pick-btn" @click.stop="pickFromDz('docs')">
                📄 문서 선택
              </button>
              <button class="dz-pick-btn" @click.stop="pickFromDz('images')">
                🖼 이미지 선택
              </button>
              <button class="dz-pick-cancel" @click.stop="closeDzPicker">
                취소
              </button>
            </div>
          
            <div
              v-if="dzPickerOpen"
              class="dz-picker-mask"
              @click="closeDzPicker"
            />
          
            <!-- 숨김 input -->
            <input
              ref="fileInputDocs"
              type="file"
              multiple
              style="display:none"
              @change="onPicked"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
            />
          
            <input
              ref="fileInputImages"
              type="file"
              multiple
              style="display:none"
              @change="onPicked"
              accept="image/*"
            />
          </div>
          
          <!-- ===== 업로드된 파일 목록 ===== -->
          <div v-if="uploadedFiles.length" class="sheet-files">
            <div
              v-for="(file, index) in uploadedFiles"
              :key="index"
              class="sheet-file"
            >
              <div class="file-kind">
                {{ resolveEmoji(file.name) }}
              </div>
              <div class="file-name">
                {{ file.name }}
              </div>
              <div class="file-size">
                {{ (file.size/1024/1024).toFixed(2) }} MB
              </div>
              <button
                class="file-remove"
                @click="removeFile(index)"
              >
                삭제
              </button>
            </div>
          </div>
        </div>
        
        <!-- 질병 설명일 때만 노출 -->
        <div v-if="mode==='info'" class="demographicRow">
        
          <div class="demoItem">
            <label>성별</label>
            <select v-model="gender" class="selectBox">
              <option value="무관">무관</option>
              <option value="남">남</option>
              <option value="여">여</option>
            </select>
          </div>
        
          <div class="demoItem">
            <label>나이</label>
            <select v-model="ageGroup" class="selectBox">
              <option value="전연령">전연령</option>
              <option value="0–9세">0–9세</option>
              <option value="10대">10대</option>
              <option value="20대">20대</option>
              <option value="30대">30대</option>
              <option value="40대">40대</option>
              <option value="50대">50대</option>
              <option value="60대">60대</option>
              <option value="70대">70대</option>
              <option value="80대">80대</option>
              <option value="90대 이상">90대 이상</option>
            </select>
          </div>
        
        </div>

        <button
          class="btnPrimary"
          :disabled="loading"
          @click="closeSearchList(); callAI()"
        >
          {{ loading ? `AI 분석 중... (${elapsedSeconds}초)` : "AI 분석 실행" }}
        </button>
      </div>

      <!-- ===================== -->
      <!-- 3️⃣ 고지문 -->
      <!-- ===================== -->
      <div v-if="aiResult" class="notice">
        본 안내는 참고용이며, 최종 진단은 의료진 판단에 따르며
        보험금 지급 여부는 보험사 약관 및 심사 기준에 따릅니다.
      </div>

      <!-- ===================== -->
      <!-- 4️⃣ 결과 -->
      <!-- ===================== -->
      <div v-if="aiResult" class="card resultCard">
        <div class="cardTitle">AI 분석 결과</div>
        <div class="resultContent" v-html="formattedResult"></div>
      </div>

      <div v-if="error" class="errorBox">
        {{ error }}
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, watch, computed } from "vue"
import MarkdownIt from "markdown-it"
import DOMPurify from "dompurify"

const searchKeyword = ref("")
const searchResults = ref([])
const selectedDiseases = ref([])
const elapsedSeconds = ref(0)
let timer = null

const tableRef = ref(null)
const showFade = ref(true)
const gender = ref("무관")
const ageGroup = ref("전연령")

const mode = ref("coverage") // info | coverage
const coverageText = ref("")

const loading = ref(false)
const aiResult = ref(null)
const error = ref(null)
const searchCount = ref(0)

const uploadedFiles = ref([])
const isOver = ref(false)
const dzPickerOpen = ref(false)

const fileInputDocs = ref(null)
const fileInputImages = ref(null)

const showToast = ref(false)
const toastMessage = ref("")
const toastType = ref("error")

const md = new MarkdownIt({
  html: false,
  linkify: true,
  breaks: true
}).enable(["table"])

function showError(message) {
  toastType.value = "error"
  toastMessage.value = message
  showToast.value = true

  setTimeout(() => {
    showToast.value = false
  }, 2500)
}

function formatAIResult(text = "") {
  text = String(text)
    .replace(/\r\n?/g, "\n")
    .replace(/\n{3,}/g, "\n\n")

  const sanitizeAll = (html) =>
    DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        "div","p","br","strong","b","em","u","span",
        "ul","ol","li","blockquote","code","pre",
        "table","thead","tbody","tr","th","td",
        "caption","col","colgroup","hr",
        "h1","h2","h3","h4","h5","h6","a"
      ],
      ALLOWED_ATTR: [
        "class","rowspan","colspan","align",
        "width","href","title","target","rel"
      ],
    })

  // ```html 블록 분리 처리
  const re = /```html([\s\S]*?)```/gi
  let out = ""
  let last = 0
  let m

  while ((m = re.exec(text)) !== null) {
    const before = text.slice(last, m.index)
    if (before) {
      out += `<div class="md-block">${md.render(before)}</div>`
    }
    const rawHtml = (m[1] || "").trim()
    out += `<div class="html-block">${sanitizeAll(rawHtml)}</div>`
    last = re.lastIndex
  }

  const tail = text.slice(last)
  if (tail) {
    out += `<div class="md-block">${md.render(tail)}</div>`
  }

  // 표 래핑 (가로 스크롤용)
  out = out.replace(
    /(<table[\s\S]*?<\/table>)/gi,
    '<div class="table-scroll">$1</div>'
  )

  return sanitizeAll(out)
}

const formattedResult = computed(() => {
  return formatAIResult(aiResult.value)
})

watch(selectedDiseases, (val) => {
  console.log("선택 변경:", val)
}, { deep: true })

watch(searchKeyword, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    searchResults.value = []
    searchCount.value = 0
    showFade.value = false
  }
})


/* =========================
   1️⃣ 질병 검색
========================= */
async function searchDisease() {
  if (!searchKeyword.value) {
    searchResults.value = []
    searchCount.value = 0
    showFade.value = false   // 🔥 검색어 없으면 페이드 제거
    return
  }

  try {
    const res = await fetch(
      `/api/disease/search?q=${encodeURIComponent(searchKeyword.value)}`
    )

    if (!res.ok) return

    const data = await res.json()

    searchResults.value = data
    searchCount.value = data.length
    showFade.value = data.length > 5   // 🔥 여기 추가

    console.log("검색 결과 수:", data.length)

  } catch (e) {
    console.error(e)
  }
}

function addDisease(item) {

  const index = selectedDiseases.value.findIndex(
    d => d.code === item.code
  )

  if (index === -1) {
    // 🔵 코드 자체가 없으면 추가
    selectedDiseases.value.push(item)

  } else {
    const existing = selectedDiseases.value[index]

    if (existing.name === item.name) {
      // 🔴 코드 + 이름 모두 동일 → 해제
      selectedDiseases.value.splice(index, 1)

    } else {
      // 🟡 코드 같고 이름 다름 → name 업데이트
      selectedDiseases.value[index] = item
    }
  }

  console.log("현재 선택된 질병:", selectedDiseases.value)
}

function removeDisease(code) {
  selectedDiseases.value =
    selectedDiseases.value.filter(d => d.code !== code)
}

function isSelected(code, name) {
  return selectedDiseases.value.some(
    d => d.code === code && d.name === name
  )
}

function handleScroll() {
  const el = tableRef.value
  if (!el) return

  const atBottom =
    el.scrollTop + el.clientHeight >= el.scrollHeight - 2

  showFade.value = !atBottom
}

function closeSearchList() {
  searchResults.value = []
  searchCount.value = 0
  showFade.value = false
}

/* 드래그 */
function onDragEnter() {
  isOver.value = true
}
function onDragOver() {
  isOver.value = true
}
function onDragLeave() {
  isOver.value = false
}
function onDrop(e) {
  isOver.value = false
  const files = Array.from(e.dataTransfer.files)
  uploadedFiles.value.push(...files)
}

/* 클릭 picker */
function openDzPicker() {
  dzPickerOpen.value = true
}
function closeDzPicker() {
  dzPickerOpen.value = false
}

function pickFromDz(type) {
  if (type === "docs") {
    fileInputDocs.value?.click()
  } else {
    fileInputImages.value?.click()
  }
}

function onPicked(e) {
  const files = Array.from(e.target.files)
  uploadedFiles.value.push(...files)
  
  dzPickerOpen.value = false   // 🔥 추가
  
  e.target.value = null
}

function removeFile(index) {
  uploadedFiles.value.splice(index, 1)
}

function resolveEmoji(name) {
  const ext = name.split(".").pop().toLowerCase()
  if (["pdf"].includes(ext)) return "📄"
  if (["doc","docx"].includes(ext)) return "📝"
  if (["xls","xlsx"].includes(ext)) return "📊"
  if (["png","jpg","jpeg","gif"].includes(ext)) return "🖼"
  return "📁"
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

function getOrCreateSessionId() {
  let sessionId = localStorage.getItem("throw_session_id")

  if (!sessionId) {
    sessionId = generateUUID()
    localStorage.setItem("throw_session_id", sessionId)
  }

  return sessionId
}

/* =========================
   2️⃣ 파일 처리
========================= */

/* =========================
   3️⃣ AI 호출
========================= */
async function callAI() {
  error.value = null
  aiResult.value = ""

  
  if (selectedDiseases.value.length === 0) {
    showError("질병을 먼저 선택해주세요.")
    return
  }

  if (mode.value === "coverage") {

    const hasCoverageText = coverageText.value.trim().length > 0
    const hasFiles = uploadedFiles.value.length > 0

    if (!hasCoverageText && !hasFiles) {
      showError("보장 내용을 입력하거나 보험증권 / 설계서를 업로드해주세요.")
      return
    }

  }
  
  loading.value = true
  
  elapsedSeconds.value = 0

  // 🔥 타이머 시작
  timer = setInterval(() => {
    elapsedSeconds.value++
  }, 1000)

  //const API_BASE = "http://15.165.60.45:5000"
  const API_BASE = ""

  const sessionId = getOrCreateSessionId()

  const abortController = new AbortController()

  try {

    const fd = new FormData()
    fd.append("session_id", sessionId)

    // -----------------------------
    // 1️⃣ question 구성
    // -----------------------------
    let questionText = ""

    if (mode.value === "info") {

  questionText = `
[질병 설명 요청]

■ 대상 정보
성별: ${gender.value}
나이: ${ageGroup.value}

이 정보가 특정되어 있을 경우,
해당 집단 기준으로 분석을 수행하세요.
반드시 일반 평균과 차이점을 명시하세요.

■ 질병
${JSON.stringify(selectedDiseases.value, null, 2)}

위 대상 정보를 질병에 대해서 설명해주세요.
  `

    } else {

      questionText = `
[보험금분석 요청]

■ 선택 질병
${JSON.stringify(selectedDiseases.value, null, 2)}

■ 보장 참고내용
${coverageText.value || "없음"}

위 내용 또는 파일에서 읽어온 데이터를 기준으로
1. 받을 수 있는 보험금
2. 부족한 보장
을 분석해주세요.
      `
    }

    fd.append("question", questionText)

    // -----------------------------
    // 2️⃣ category / job 구성
    // -----------------------------
    let categoryValue = ""
    let jobValue = "보험설계사"

    if (mode.value === "info") {
      categoryValue = "질병설명"
    } else {
      categoryValue = "보험금분석"
    }

    fd.append("category", categoryValue)
    fd.append("job", jobValue)

    // -----------------------------
    // 3️⃣ 파일 첨부
    // -----------------------------
    if (uploadedFiles.value.length) {
      uploadedFiles.value.forEach(file => {
        fd.append("files", file)
      })
    }

    // -----------------------------
    // 4️⃣ 스트리밍 요청
    // -----------------------------
    const res = await fetch(`${API_BASE}/chat/stream-file`, {
      method: "POST",
      body: fd,
      signal: abortController.signal
    })

    if (!res.ok || !res.body) throw new Error()

    const reader = res.body.getReader()
    const decoder = new TextDecoder("utf-8")

    let done = false
    let resultText = ""

    while (!done) {
      const { value, done: doneReading } = await reader.read()
      done = doneReading

      if (value) {
        const chunk = decoder.decode(value, { stream: true })
        resultText += chunk
        aiResult.value = resultText
      }
    }

  } catch (e) {
    error.value = "AI 분석 중 오류가 발생했습니다."
  } finally {
    loading.value = false
    
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }
}
</script>

<style>

.container {
  text-align:left;
  max-width: 1020px;
  margin: 5px auto 20px; 
  padding:24px 10px 24px;
  background: rgba(255,255,255,.75);
  border: 1px solid rgba(17,24,39,.08);
  border-radius: 18px;
  overflow:hidden;
}

.card {
  background: white;
  border-radius: 16px;
  padding: 22px;
  margin-bottom: 20px;
}

.cardTitle {
  font-weight: 700;
  margin-bottom: 14px;
}

.input {
  width: 100%;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #ddd;
}

.searchList {
  border: 1px solid #eee;
  margin-top: 6px;
  border-radius: 10px;
  max-height: 200px;
  overflow-y: auto;
}

.searchItem {
  padding: 8px 12px;
  cursor: pointer;
}

.searchItem:hover {
  background: #f3f4f6;
}

.selectedWrap {
  margin-top: 10px;
}

.chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;

  padding: 10px 14px;   /* 🔥 터치 영역 확대 */
  background: #e0f2fe;
  border-radius: 22px;
  margin: 6px 6px 0 0;
  font-size: 13px;

  cursor: pointer;
  transition: all 0.15s ease;
}

.chip:hover {
  background: #bae6fd;
}

.chipClose {
  font-weight: 700;
  font-size: 14px;
  opacity: 0.7;
}

.chip span {
  margin-left: 6px;
  cursor: pointer;
}

.modeButtons {
  display: flex;
  gap: 10px;
  margin-bottom: 16px;
}

.modeButtons button {
  flex: 1;
  padding: 10px;
  border-radius: 10px;
  border: 1px solid #ddd;
}

.modeButtons .active {
  background: #111827;
  color: white;
}

textarea {
  width: 100%;
  min-height: 140px;
  margin-bottom: 12px;
  border-radius: 10px;
  padding: 10px;
  border: 1px solid #ddd;
}

.btnPrimary {
  width: 100%;
  padding: 14px;
  border-radius: 14px;   /* 12 → 14로 통일 */
  border: none;

  background: linear-gradient(
    135deg,
    #3b82f6,   /* 살짝 밝은 블루 */
    #2563eb    /* 기존 색 유지 */
  );

  color: white;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;

  margin-top: 24px;   /* 🔥 추가 */
  transition: all 0.25s ease;
}

.btnPrimary:hover {
  transform: translateY(-3px);

  background: linear-gradient(
    135deg,
    #2563eb,
    #1e40af
  );

}


.notice {
  font-size: 12px;
  opacity: 0.7;
  margin-bottom: 12px;
}

.errorBox {
  padding: 12px;
  border-radius: 10px;
  background: rgba(239,68,68,0.1);
  color: #b91c1c;
}

.searchRow {
  display: flex;
  gap: 10px;
}

.btnSearch {
  padding: 12px 16px;
  border-radius: 10px;
  border: none;
  background: #111827;
  color: white;
  font-weight: 600;
}

.searchItem {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #f1f1f1;
}

.btnSelect {
  padding: 6px 10px;
  border-radius: 8px;
  background: #2563eb;
  color: white;
  border: none;
  font-size: 12px;
}
.searchWrap {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.btnSearchFull {
  width: 100%;
  padding: 14px;
  border-radius: 14px;
  border: none;

  font-weight: 700;
  font-size: 14px;
  cursor: pointer;

  background: linear-gradient(
    135deg,
    #22c55e,
    #15803d
  );

  color: white;


  transition: all 0.25s ease;
}

.btnSearchFull:hover {
  transform: translateY(-3px);

  background: linear-gradient(
    135deg,
    #16a34a,
    #14532d
  );

}
.searchRowItem {
  display: grid;
  grid-template-columns: 70px 1fr 70px;
  align-items: center;

  padding: 8px 12px;   /* 🔥 슬림 */
  font-size: 14px;

  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  transition: background 0.15s ease;
}

.searchRowItem:hover {
  background: #f8fafc;
}

.searchRowItem.active {
  background: #e0f2fe;
}

.colCode {
  font-weight: 600;
}

.colName {
  padding: 0 6px;
}

.btnSelect {
  height: 32px;
  font-size: 12px;
  border-radius: 8px;
  background: #2563eb;
  color: white;
  border: none;
}

.searchRowItem.active .btnSelect {
  background: #16a34a;
}

.searchCount {
  margin-left: 6px;
  font-weight: 600;
  opacity: 0.85;
}

.searchTableWrapper {
  position: relative;
  margin-top: 10px;
}

.searchTable {
  border: 1px solid #eee;
  border-radius: 12px;
  overflow-y: auto;
  max-height: 240px;
  background: white;
}

/* 🔥 진짜 페이드 
.fadeOverlay {
  position: absolute;
  bottom: 32px;    
  left: 0;
  right: 0;
  height: 40px;
  pointer-events: none;

  background: linear-gradient(
    to bottom,
    rgba(255,255,255,0),
    rgba(255,255,255,1)
  );
}*/

/* 행 */
.searchRowItem {
  display: grid;
  grid-template-columns: 70px 1fr 70px;
  align-items: center;
  padding: 8px 12px;
  font-size: 14px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  transition: background 0.15s ease;
}

.searchRowItem:hover {
  background: #f8fafc;
}

.searchRowItem.active {
  background: #e0f2fe;
}


/* 🔥 개수 문구 */
.scrollHint {
  text-align: center;
  font-size: 12px;
  color: #64748b;
  padding: 8px 0px;
}

.introSimple{
  background:#f8fafc;
  border:1px solid #e5e7eb;
}

.introText{
  font-size:13px;
  line-height:1.6;
  color:#334155;
}

.introCard{
  padding: 32px 24px;
  border-radius: 18px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.introRow{
  display:flex;
  flex-direction:column;   /* 🔥 세로 정렬 */
  align-items:center;      /* 🔥 가로 중앙 */
  text-align:center;       /* 🔥 텍스트 중앙 */
  gap:10px;
}

.introIcon{
  width: 40px;
  height: 40px;
  border-radius: 14px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size: 18px;

  background: rgba(22, 163, 74, 0.10);
  border: 1px solid rgba(22, 163, 74, 0.18);
}


.introCopy{
  display:flex;
  flex-direction:column;
  align-items:center;      /* 🔥 내부도 중앙 */
  gap:6px;
}

.introLine1{
  font-weight: 800;
  font-size: 18px;
  letter-spacing: -0.2px;
  color:#0f172a;
}

.introLine2{
  font-size:15px;
  color:#475569;
  line-height:1.6;
  text-align:center;
}

.introChip{
  display:inline-block;
  align-items:center;
  padding: 6px 12px;
  border-radius: 999px;
  margin: 0 6px 0 0;

  font-size: 13px;
  font-weight: 800;
  color:#166534;
  background: rgba(22, 163, 74, 0.10);
  border: 1px solid rgba(22, 163, 74, 0.18);
}

/* ===== 드롭존 ===== */
.dropzone{ border:2px dashed #94a3b8;  margin-bottom: 20px; border-radius:12px; padding:20px; text-align:center; background:#f8fafc; transition:border-color .15s, background .15s; position:relative; }
.dropzone.over{ border-color:#3b82f6; background:#eef6ff; }
.dz-icon{ font-size:24px; margin-bottom:6px; }
.dz-title{ font-size:14px; font-weight:400; color:#0f172a; }
.dz-hint{ font-size:12px; color:#64748b; }

/* 미니 픽커 */
.dz-picker{
  position:absolute;
  top:50%;
  left:50%;
  transform:translate(-50%, -50%);

  display:grid;
  gap:8px;
  min-width:220px;

  padding:12px;
  border:1px solid #E5E7EB;
  border-radius:12px;
  background:#fff;

  /* 🔥 크래시 의심 요소 제거 */
  box-shadow:none;
  animation:none;
  z-index:20;
}
.dz-pick-btn, .dz-pick-cancel{ padding:10px 12px; border-radius:10px; border:1px solid #E5E7EB; background:#fff; cursor:pointer; font-weight:700; }
.dz-pick-btn:hover{ background:#F3F4F6; }
.dz-pick-cancel{ color:#6B7280; }
.dz-picker-mask{
  position:absolute;
  inset:0;
  background:transparent; /* rgba도 제거 */
  z-index:10;
}
@keyframes dz-pop{ from{ transform:translate(-50%, -46%); opacity:.0; } to{ transform:translate(-50%, -50%); opacity:1; } }

/* ===== 파일 리스트 ===== */
.sheet-files{ margin-top:12px; display:grid; gap:8px; }
.sheet-file{ display:grid; grid-template-columns:32px 1fr auto auto; align-items:center; gap:8px; padding:8px; border:1px solid #e5e7eb; border-radius:10px; background:#fff; }
.file-kind{ width:32px; text-align:center; }
.file-name{ overflow:hidden; text-overflow:ellipsis; white-space:nowrap; }
.file-size{ font-size:12px; color:#64748b; }
.file-remove{ border:1px solid #e5e7eb; background:#f9fafb; border-radius:8px; padding:4px 8px; cursor:pointer; }
.file-remove:hover{ background:#f3f4f6; }

/* ===================================== */
/* 📊 resultContent - 여유 있는 카드형 표 */
/* ===================================== */

.resultContent {
  font-size: 15px;
  line-height: 1.75;   /* 🔥 전체 줄간격 증가 */
  color: #1f2937;
}

/* 문단 */
.resultContent p {
  margin: 14px 0;      /* 🔥 문단 간격 확대 */
}

/* 리스트 */
.resultContent ul,
.resultContent ol {
  margin: 14px 0;
  padding-left: 22px;
}

.resultContent li {
  margin: 10px 0;      /* 🔥 리스트 간격 확대 */
}

/* 제목 */
.resultContent h1,
.resultContent h2,
.resultContent h3,
.resultContent h4 {
  margin-top: 28px;
  margin-bottom: 12px;
  font-weight: 600;
  letter-spacing: -0.2px;
}

/* ===================== */
/* 테이블 카드 스타일 */
/* ===================== */

.resultContent .table-scroll {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;

  margin: 22px 0;
  padding: 14px;
  background: #ffffff;
  border-radius: 16px;
}

/* 표 */
.resultContent .table-scroll table,
.resultContent table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

/* 헤더 */
.resultContent th {
  padding: 16px 18px;    /* 🔥 세로 패딩 증가 */
  background: #f8fafc;
  font-weight: 600;
  border-bottom: 1px solid #e5e7eb;
  text-align: center;
  color: #0f172a;
}

/* 셀 */
.resultContent td {
  padding: 18px 18px;    /* 🔥 세로 패딩 증가 */
  border-bottom: 1px solid #f1f5f9;
  text-align: center;
  color: #334155;
  white-space: nowrap;
}

/* 첫 컬럼 강조 */
.resultContent td:first-child {
  text-align: left;
  font-weight: 500;
  color: #111827;
}

/* zebra */
.resultContent tbody tr:nth-child(even) {
  background: #fafafa;
}

/* hover */
.resultContent tbody tr:hover {
  background: #f1f5f9;
  transition: background 0.15s ease;
}

/* 마지막 줄 */
.resultContent tr:last-child td {
  border-bottom: none;
}

/* =========================
   성별 / 나이 선택 영역
========================= */

.demographicRow {
  display: flex;
  gap: 14px;
  margin: 18px 0 6px;
}

.demoItem {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.demoItem label {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 6px;
  color: #374151;
}

/* select 박스 */
.selectBox {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #f9fafb;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  appearance: none;
}

/* hover */
.selectBox:hover {
  border-color: #cbd5e1;
}

/* focus */
.selectBox:focus {
  outline: none;
  border-color: #2563eb;
  background: #ffffff;
}


/* ===============================
   Glass Toast - Blue/Navy Final
   =============================== */

.glass-toast {
  position: fixed;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 998;
}

/* 캡슐 본체 */
.glass-inner {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 32px;
  border-radius: 999px;

  /* 🔥 최종 사용 블루-네이비 그라데이션 */
  background: linear-gradient(
    135deg,
    rgba(37, 99, 235, 0.45),
    rgba(17, 24, 139, 0.35)
  );

  border: 1px solid rgba(255, 255, 255, 0.35);

  color: #ffffff;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: -0.2px;
}

/* 아이콘 */
.glass-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2563eb, #111889);

  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 14px;
  color: white;

}

/* 하이라이트 (유리 느낌 핵심) */
.glass-inner::before {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: linear-gradient(
    135deg,
    rgba(255,255,255,0.65),
    rgba(255,255,255,0.05)
  );
  opacity: 0.35;
  pointer-events: none;
}

/* 애니메이션 */
.glass-toast-enter-active,
.glass-toast-leave-active {
  transition: all 0.4s ease;
}

.glass-toast-enter-from {
  opacity: 0;
  transform: translate(-50%, -25px) scale(0.95);
}

.glass-toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -25px) scale(0.95);
}

/* 모바일 보정 */
@media (max-width: 600px) {
  .searchRowItem {
    grid-template-columns: 60px 1fr 75px;
  }

  .btnSelect {
    height: 36px;
  }
  
  .introCard{
    padding: 24px 18px;
  }

  .introLine1{
    font-size: 17px;
    line-height: 1.4;
  }

  .introLine2{
    font-size: 14px;
    line-height: 1.7;
  }

  .introChip{
    display:inline-block;
    margin: 4px 6px;
  }
  
  .demographicRow {
    flex-direction: column;
  }

}

</style>